(function () {
  'use strict';

  function initSplitGallery(root) {
    var galleries = root.querySelectorAll('[data-split-gallery]');
    galleries.forEach(function (gallery) {
      if (gallery.dataset.splitGalleryInit === 'true') return;
      gallery.dataset.splitGalleryInit = 'true';

      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-split-gallery-slide]'));
      if (slides.length <= 1) return;

      var paginationItems = Array.prototype.slice.call(gallery.querySelectorAll('[data-split-gallery-pagination]'));
      var prevButton = gallery.querySelector('[data-split-gallery-prev]');
      var nextButton = gallery.querySelector('[data-split-gallery-next]');
      var currentIndex = slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      if (currentIndex < 0) currentIndex = 0;

      var touchStartX = 0;
      var touchStartY = 0;
      var touchDeltaX = 0;
      var touchDeltaY = 0;
      var touchActive = false;

      function goTo(index) {
        var total = slides.length;
        if (!total) return;
        var nextIndex = (index + total) % total;
        if (nextIndex === currentIndex) return;
        currentIndex = nextIndex;
        updateUI();
      }

      function updateUI() {
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === currentIndex);
        });
        paginationItems.forEach(function (item, itemIndex) {
          item.classList.toggle('is-active', itemIndex === currentIndex);
        });
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          goTo(currentIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          goTo(currentIndex + 1);
        });
      }

      paginationItems.forEach(function (item) {
        item.addEventListener('click', function () {
          var index = Number(item.dataset.slideIndex);
          if (!Number.isNaN(index)) goTo(index);
        });
      });

      gallery.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) return;
        var touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchDeltaX = 0;
        touchDeltaY = 0;
        touchActive = true;
      }, { passive: true });

      gallery.addEventListener('touchmove', function (event) {
        if (!touchActive || event.touches.length !== 1) return;
        var touch = event.touches[0];
        touchDeltaX = touch.clientX - touchStartX;
        touchDeltaY = touch.clientY - touchStartY;
      }, { passive: true });

      gallery.addEventListener('touchend', function () {
        if (!touchActive) return;
        var absX = Math.abs(touchDeltaX);
        var absY = Math.abs(touchDeltaY);
        if (absX > 40 && absX > absY) {
          if (touchDeltaX < 0) {
            goTo(currentIndex + 1);
          } else {
            goTo(currentIndex - 1);
          }
        }
        touchActive = false;
        touchDeltaX = 0;
        touchDeltaY = 0;
      }, { passive: true });

      updateUI();
    });
  }

  function initProductsCarousel(root) {
    root.querySelectorAll('[data-split-products-track]').forEach(function (track) {
      if (track.dataset.splitProductsInit === 'true') return;
      track.dataset.splitProductsInit = 'true';

      var wrapper = track.closest('.item-selection-split__products-wrapper');
      var prevButton = wrapper && wrapper.querySelector('[data-split-products-prev]');
      var nextButton = wrapper && wrapper.querySelector('[data-split-products-next]');
      var productItems = Array.prototype.slice.call(track.querySelectorAll('[data-split-product-item]'));
      var pagination = wrapper && wrapper.querySelector('[data-split-products-pagination]');

      if (wrapper && !pagination && productItems.length > 4) {
        pagination = document.createElement('div');
        pagination.className = 'item-selection-split__products-pagination';
        pagination.dataset.splitProductsPagination = '';
        pagination.setAttribute('aria-label', track.dataset.splitPaginationLabel || 'Product pagination');

        var pageCount = Math.ceil(productItems.length / 4);
        Array.from({ length: pageCount }).forEach(function (_page, index) {
          var paginationItem = document.createElement('button');
          paginationItem.type = 'button';
          paginationItem.className = 'item-selection-split__products-pagination-item';
          paginationItem.dataset.splitProductsPaginationItem = '';
          paginationItem.dataset.productIndex = String(index);
          paginationItem.setAttribute(
            'aria-label',
            (track.dataset.splitProductLabel || 'Go to product __INDEX__').replace('__INDEX__', String(index + 1))
          );
          if (index === 0) {
            paginationItem.classList.add('is-active');
            paginationItem.setAttribute('aria-current', 'true');
          }
          pagination.appendChild(paginationItem);
        });

        track.insertAdjacentElement('afterend', pagination);
      }

      var paginationItems = wrapper
        ? Array.prototype.slice.call(wrapper.querySelectorAll('[data-split-products-pagination-item]'))
        : [];
      var updateFrame = 0;

      function updatePagination() {
        if (!paginationItems.length) return;
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var scrollPosition = Math.min(maxScroll, Math.abs(track.scrollLeft));
        var activeIndex = 0;
        if (maxScroll > 2 && paginationItems.length > 1) {
          activeIndex = Math.round((scrollPosition / maxScroll) * (paginationItems.length - 1));
        }

        paginationItems.forEach(function (item, index) {
          var isActive = index === activeIndex;
          item.classList.toggle('is-active', isActive);
          if (isActive) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        });
      }

      function updateButtons() {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var scrollPosition = Math.min(maxScroll, Math.abs(track.scrollLeft));
        if (prevButton) prevButton.disabled = scrollPosition <= 2;
        if (nextButton) nextButton.disabled = scrollPosition >= maxScroll - 2;
        updatePagination();
      }

      function move(direction) {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var isRtl = window.getComputedStyle(track).direction === 'rtl';
        var target = direction > 0 ? maxScroll : 0;
        track.scrollTo({
          left: isRtl ? -target : target,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      if (prevButton) prevButton.addEventListener('click', function () { move(-1); });
      if (nextButton) nextButton.addEventListener('click', function () { move(1); });
      paginationItems.forEach(function (paginationItem) {
        paginationItem.addEventListener('click', function () {
          var itemIndex = Number(paginationItem.dataset.productIndex);
          if (Number.isNaN(itemIndex)) return;
          var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          var lastIndex = Math.max(1, paginationItems.length - 1);
          var offset = maxScroll * (itemIndex / lastIndex);
          var isRtl = window.getComputedStyle(track).direction === 'rtl';
          track.scrollTo({
            left: isRtl ? -offset : offset,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        });
      });
      track.addEventListener('scroll', function () {
        if (updateFrame) return;
        updateFrame = window.requestAnimationFrame(function () {
          updateFrame = 0;
          updateButtons();
        });
      }, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  function resetSplitSection(root) {
    root.querySelectorAll('[data-split-gallery]').forEach(function (gallery) {
      delete gallery.dataset.splitGalleryInit;
    });
    root.querySelectorAll('[data-split-products-track]').forEach(function (track) {
      delete track.dataset.splitProductsInit;
    });
  }

  function initItemSelectionSplit(root) {
    initSplitGallery(root);
    initProductsCarousel(root);
  }

  function initVisibleSplitSection(section) {
    if (!section || section.dataset.splitSectionBound === 'true') return;
    section.dataset.splitSectionBound = 'true';
    initItemSelectionSplit(section);
  }

  function observeSplitSections() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.item-selection-split'));
    if (!sections.length) return;

    var isHome = document.body && document.body.classList.contains('template-index');
    if (!isHome || typeof IntersectionObserver === 'undefined') {
      sections.forEach(initVisibleSplitSection);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        initVisibleSplitSection(entry.target);
        observer.unobserve(entry.target);
      });
    }, {
      root: null,
      rootMargin: '300px 0px',
      threshold: 0.01
    });

    sections.forEach(function (section, index) {
      if (index === 0) {
        initVisibleSplitSection(section);
        return;
      }
      observer.observe(section);
    });
  }

  function boot() {
    observeSplitSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    resetSplitSection(event.target);
    initItemSelectionSplit(event.target);
  });
})();
